import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/holdings'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { guest: true }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: { guest: true }
    },
    {
      path: '/force-password-change',
      name: 'ForcePasswordChange',
      component: () => import('@/views/ForcePasswordChange.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/access-closed',
      name: 'AccessClosed',
      component: () => import('@/views/AccessClosed.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/holdings',
      name: 'Holdings',
      component: () => import('@/views/Holdings.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/holdings/:id',
      name: 'HoldingDetail',
      component: () => import('@/views/HoldingDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/transactions',
      redirect: '/holdings'
    },
    {
      path: '/funds',
      name: 'Funds',
      component: () => import('@/views/Funds.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/funds/:id',
      name: 'FundDetail',
      component: () => import('@/views/FundDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/parameter-explanations',
      name: 'ParameterExplanations',
      component: () => import('@/views/ParameterExplanations.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/messages',
      name: 'Messages',
      component: () => import('@/views/Messages.vue'),
      meta: { requiresAuth: true }
    }
  ]
});

// 路由守卫
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();

  // 如果 store 还在初始化（有 token 但无 user），先 fetchUserInfo
  if (authStore.token && !authStore.user) {
    await authStore.fetchUserInfo();
  }

  // 1. 需要认证但未登录 → 登录页
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next('/login');
  }

  // 2. 已登录但访问 guest 页面（非 ForgotPassword）→ 首页
  if (to.meta.guest && authStore.isAuthenticated && to.name !== 'ForgotPassword') {
    return next('/holdings');
  }

  // 3. 强制改密守卫（mustChangePassword 为 true 且不在改密页面）
  if (
    authStore.isAuthenticated &&
    authStore.mustChangePassword &&
    to.name !== 'ForcePasswordChange' &&
    to.name !== 'AccessClosed'
  ) {
    return next('/force-password-change');
  }

  // 4. 入口访问权限检查（已登录、不在 access-closed 页、需要认证的路由）
  if (
    authStore.isAuthenticated &&
    to.meta.requiresAuth &&
    to.name !== 'AccessClosed' &&
    to.name !== 'ForcePasswordChange'
  ) {
    try {
      const check = await authStore.checkAccess();
      if (!check.hasAccess) {
        return next('/access-closed');
      }
    } catch {
      // checkAccess 失败时静默放行，避免网络问题阻断导航
    }
  }

  next();
});

export default router;
